import React from 'react';
import { Box, Paper, Typography, Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';

import useCurrency from '../../../hooks/common/useCurrency';
import OrderStatusBadge from '../Table/OrderStatusBadge';

dayjs.extend(relativeTime);

const OrderHeader = ({ order }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');
    const { format: formatPrice } = useCurrency();

    const placedAt = order?.placed_at || order?.created_at;

    return (
        <Paper
            elevation={0}
            sx={{
                p: { xs: 2.5, md: 3.5 },
                borderRadius: 3,
                border: (t) => `1px solid ${t.palette.divider}`,
                mb: 3,
            }}
        >
            <Stack
                direction={{ xs: 'column', md: 'row' }}
                spacing={2}
                alignItems={{ xs: 'flex-start', md: 'center' }}
                justifyContent="space-between"
            >
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={1.5}
                        alignItems={{ xs: 'flex-start', sm: 'center' }}
                        mb={0.5}
                    >
                        <Typography
                            variant="h5"
                            fontWeight={700}
                            sx={{ wordBreak: 'break-all', lineHeight: 1.3 }}
                        >
                            {isArabic ? 'طلب' : 'Order'} #{order?.order_number || order?.id}
                        </Typography>
                        <OrderStatusBadge status={order?.status} />
                    </Stack>
                    {placedAt && (
                        <Tooltip title={dayjs(placedAt).format('YYYY-MM-DD HH:mm')}>
                            <Typography variant="body2" color="text.secondary">
                                {isArabic ? 'تم الطلب' : 'Placed'} {dayjs(placedAt).fromNow()}
                            </Typography>
                        </Tooltip>
                    )}
                </Box>

                <Box sx={{ textAlign: { xs: 'start', md: 'end' }, flexShrink: 0 }}>
                    <Typography variant="caption" color="text.secondary">
                        {isArabic ? 'الإجمالي' : 'Grand Total'}
                    </Typography>
                    <Typography variant="h4" fontWeight={700} color="primary.main" sx={{ whiteSpace: 'nowrap' }}>
                        {formatPrice(order?.grand_total ?? 0)}
                    </Typography>
                </Box>
            </Stack>
        </Paper>
    );
};

export default OrderHeader;
